import React from 'react'
import { Link } from 'react-router-dom';

function Membership() {
    return (
        <section className="w-full bg-gradient-radial py-5 lg:py-5 px-6 md:px-28 lg:px-40 font-urbanist">
            <div className="flex justify-center">
                <div className="bg-white rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-between shadow-lg max-w-[100%] w-full">
                    <p className="text-xl sm:text-2xl md:text-2xl font-bold text-[#000000] mb-4 sm:mb-0 sm:mr-6 text-center sm:text-left">
                        Stand out with trust and authenticity—get your membership today.
                    </p>
                    <Link to='/services/our-services' className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-8 rounded-lg text-lg sm:text-xl transition duration-300 ease-in-out flex-shrink-0 font-inter">
                        Join us
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default Membership;